module.exports = __webpack_public_path__ + "img/cardio.23909f34.jpg";